import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { adminCatalogReducer } from './catalog/admin-catalog.reducer';
import { adminLocationReducer } from './location/admin-location.reducer';
import { adminUserReducer } from './user/admin-user.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('admin', {
      catalog: adminCatalogReducer,
      location: adminLocationReducer,
      user: adminUserReducer,
    }),
  ],
})
export class AdminStoreModule {}
